import { IconCustomAurora } from '@rossum/ui/icons/tabler';
import { Chip, ChipProps, SvgIcon } from '@rossum/ui/material';
import { useIntl } from '../ComponentsContext';

const AURORA_KEYWORD = 'aurora';

export const shouldDisplayAuroraChipByName = (
  name: string,
  auroraEngineEnabled: boolean
) => {
  const isAuroraInName = name.toLowerCase().includes(AURORA_KEYWORD);
  return isAuroraInName && auroraEngineEnabled;
};

export type AuroraChipProps = Omit<ChipProps, 'label'> & {
  label?: string;
};

// Consider using ConditionalAuroraChip instead of AuroraChip
export const AuroraChip = ({ label }: AuroraChipProps) => {
  const intl = useIntl();

  const resolvedLabel =
    label ??
    intl.formatMessage({
      id: 'component.auroraChip.label',
    });

  return (
    <Chip
      color="aurora"
      icon={
        <SvgIcon fontSize="large">
          <IconCustomAurora />
        </SvgIcon>
      }
      label={resolvedLabel}
    />
  );
};
